import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/fonts.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './utils/analytics/analyticsInstance';
import Clarity from '@microsoft/clarity';
import config from './types/config';

if (config.nodeEnv === 'production') {
  Clarity.init(config.clarityProjectId);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
